<template>
<b-container style="max-width: 1200px !important">

<b-row class="justify-content-center align-items-center">
        <h5 style="text-align:center">QUANTEEC x JWPlayer</h5>
</b-row>

<b-tabs>
    <b-tab :title="$ml.get('plugininstallfromCDN')">

<b-row class="justify-content-center align-items-center marginaltopsm">
        <p style="margin-bottom:0px" v-html="$ml.get('pluginjwp1')">
            
        </p>
</b-row>
<b-row class="justify-content-center align-items-center">
  <ol class="center" style="margin: 10px">
          <li style="margin-bottom:10px">
              {{$ml.get('pluginp8')}}<br />
              <code>
                {{line1_jwp}}
              </code>
              <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="$refs.copied.copyToClipboard(line1_jwp)" />
          </li>
          <li style="margin-bottom:10px">
              {{$ml.get('pluginp11')}}<br /> 
              <code>{{configLine}}
              </code>
              <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="$refs.copied.copyToClipboard(configLine)" />
          </li>
          <li style="margin-bottom:10px">
              {{$ml.get('pluginjwp3')}}<br />
              <code>
                {{line3_jwp}}
              </code>
              <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="$refs.copied.copyToClipboard(line3_jwp)" />
          </li>
          
  </ol>
</b-row>

<b-row>
<b-col cols="12">
    
    <b-row class="mt-2">
      <div class="col-xl-7 col-12" v-html="$ml.get('jwp_example')" ></div>

    <vue-markdown :show="activePlugin === 'noDRM'" style="overflow: auto;" class="col-xl-7 col-12" :style="(activePlugin === 'withDRM')?'display: none' : ''" @rendered="onrender">
``` html
&lt;head>
    &lt;script src="https://content.jwplatform.com/libraries/&lt;custom_jwplayer_id>.js">&lt;/script>
    &lt;script src="https://files.quanteec.com/quanteec/latest/jwplayer.quanteec.min.js">&lt;/script> &lt;!-- 1-include QUANTEEC script-->
&lt;/head>
&lt;body>
    &lt;video id="videoplayer" class="video-js vjs-default-skin" controls>&lt;/video>

    &lt;script>
        document.addEventListener("DOMContentLoaded", function () {
            var videoSource = "https://my.server.com/videoSource.m3u8";
            
            // 2-Adjust QUANTEEC configuration
            var configQuanteec = {
                quanteecKey: "{{ streamKey }}",
                videoID: "customVideoID" // [Optional but recommended] String --> specific name to identify a video. Useful if the videosource url contains a token which is different for every users. Default: the videoSource value is used.
            };
            
            var player = jwplayer("player").setup({
                file: videoSource,
            });
            
            // 3-Register the Quanteec plugin in JWplayer after the JWplayer setup
            jwplayer_quanteec_provider.attach(configQuanteec);
        });
    &lt;/script>
&lt;body>
```
    </vue-markdown>    
    
    

    <ConfigDoc class="col-xl-5 col-12">
    </ConfigDoc>
   
</b-row>
</b-col>
</b-row>



    </b-tab>
    <b-tab :title="$ml.get('plugininstallfromNPM')">
    <b-row class="justify-content-center align-items-center marginaltopsm">
      <p style="margin-bottom:0px" v-html="$ml.get('pluginjwp1npm')">
                
      </p>
    </b-row>
    <b-row class="justify-content-center align-items-center">
      <ol class="center" style="margin: 10px">
              <li style="margin-bottom:10px">
                  {{$ml.get('pluginloginnpm')}}<br />
                  <code>
                    {{$ml.get('loginnpmcode')}}
                  </code>
                  <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="$refs.copied.copyToClipboard($ml.get('loginnpmcode'))" />
              </li>             
              <li style="margin-bottom:10px">
                  {{$ml.get('plugininstallnpm')}}<br />
                  <code>
                    {{$ml.get('installnpmpackage')}}
                  </code>
                  <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="$refs.copied.copyToClipboard($ml.get('installnpmpackage'))" />
              </li>              
              <li style="margin-bottom:10px">
                  {{$ml.get('pluginimportnpm')}}<br />
                  <code>
                    {{$ml.get('pluginimporthvideojwpsnpm')}}
                  </code>
                  <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="$refs.copied.copyToClipboard($ml.get('pluginimporthvideojwpsnpm'))" />
              </li>
            <li style="margin-bottom:10px">
            {{$ml.get('pluginp11')}}<br /> 
            <code>{{configLine}}
            </code>
            <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="$refs.copied.copyToClipboard(configLine)" />
            </li>
          <li style="margin-bottom:10px">
              {{$ml.get('pluginjwp3')}}<br />
              <code>
                {{line3_jwp}}
              </code>
              <font-awesome-icon class="pointerEltSB" style="font-size:10px; color:#2a5d77" icon="clone" @click="$refs.copied.copyToClipboard(line3_jwp)" />
          </li>
      </ol>
    </b-row>

    <b-row class="mt-2">
      <ConfigDoc class="col-12">
      </ConfigDoc>
    </b-row>
  </b-tab>
</b-tabs>


<CopiedModal ref="copied"/>


</b-container>

</template>
<script>
import ConfigDoc from '@/components/documentation/plugins/ConfigDoc.vue';
import CopiedModal from '@/components/modals/CopiedModal.vue';
import VueMarkdown from 'vue-markdown';
import Prism from 'prismjs';
import 'prismjs/themes/prism-twilight.css';
export default {
  name: 'JWPlayer',
  data: function() {
    return {
     activePlugin:"noDRM",
      line1_jwp: '<script src="https://files.quanteec.com/quanteec/latest/jwplayer.quanteec.min.js"><'+'/script>',
      line3_jwp: 'jw_quanteec_provider.attach(configQuanteec)',
    }
  },
  props: [
      "streamKey",
    "configLine"
  ],
  components: {
      VueMarkdown,
      ConfigDoc,
      CopiedModal
  },
  mounted: function() {

    this.$nextTick(() => {
        Prism.highlightAll()
      });  
  },
  methods: {
     onrender() {
        this.$nextTick(() => {
        Prism.highlightAll()
      });  
     }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.center {
    display: table;
    margin-left: auto;
    margin-right: auto;
    list-style-position: inside;
}

</style>